import { V3Models } from "@istari/istari-client";

import { ReceivingConnection } from "~/secure-connections/model/secure-connection";

import { toEditAccess } from "./to-edit-access";
import { toTransformation } from "./to-transformation";

// The sender's onward-sharing decision is learned on sync, so the API serves
// null until the first sync even though the DTO types the field as boolean.
type ReceivingConnectionDto = Omit<V3Models.ReceivingConnectionDto, "allowReshare"> & {
  allowReshare: boolean | null;
};

export function toReceivingConnection(dto: ReceivingConnectionDto): ReceivingConnection {
  return {
    kind: "receiving",
    id: dto.id,
    label: dto.label,
    description: dto.description,
    sharedId: dto.sharedId,
    objectStoreId: dto.objectStoreId,
    tenantId: dto.tenantId,
    hasCrossTenantMembers: dto.hasCrossTenantMembers ?? null,
    isArchived: dto.isArchived,
    isStarred: dto.isStarred ?? false,
    created: dto.created,
    editAccess: toEditAccess(dto.receivedAccessLevel),
    transformations: dto.transformations.map(toTransformation),
    incomingMaxInfosecLevelId: dto.incomingMaxInfosecLevelId ?? null,
    incomingInfosecSchemaId: dto.incomingInfosecSchemaId ?? null,
    allowReshare: dto.allowReshare ?? false,
  };
}
